export const sizes = {
    PET_SIZE_BELOW_TO_KNEE: 'Ниже колена',
    PET_SIZE_KNEE_DEEP: 'По колено',
    PET_SIZE_ABOVE_THE_KNEE: 'Выше колена',
}

export const weight = {
    up_to_3: 'До 3 кг',
    up_to_6: 'До 6 кг',
    up_to_10: 'До 10 кг',
    up_to_15: 'До 15 кг',
    up_to_25: 'До 25 кг',
    up_to_35: 'До 35 кг',
    '35_plus': 'От 35 кг'
}